import React, { useEffect, useState } from "react";
import Layout from "../../../../components/layouts/Layout";
import UserDetailHeader from "../../../../components/user-detail/UserDetailHeader";
import DataTable from "react-data-table-component";
// import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../../../../components/general/ProgressComponent";
import { GET_HISTORIC_CLIENTS_REPORT } from "../../../../env";
import Dropdown from 'react-bootstrap/Dropdown';
// BlobProvider, Canvas, Circle, ClipPath, Defs, Document, Ellipse, Font, G, Image, Line, LinearGradient, Link, Note, PDFDownloadLink, PDFViewer, Page, Path, Polygon, Polyline, RadialGradient, Rect, Stop, StyleSheet, Svg, Text, TextInstance, Tspan, View, createRenderer, default, pdf, render, renderToBuffer, renderToFile, renderToStream, renderToString, usePDF, version
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import * as XLSX from "xlsx";
import {
    getRecords,
    isSuccess,
    filterColumns,
    filterRowsByProperty,
    displayEnumProperty,
    // toastErrorMessages,
    catchAsync,
    addActivityLog,
    // toastSuccessMessages,

} from "../../../../helper/helper";
import moment from "moment";
import { wrap } from "lodash";

function HistoricClientReports() {

    const [filteredRows, setFilteredRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const apiQuery = {
        sortproperty: "createdAt",
        sortorder: -1,
        offset: 0,
        query: {
            critarion: { active: true },
        },
    };

    const processFetchRecords = (method, data) => {
        if (data?.status !== isSuccess) {
            // toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
        } else if (method === "get" && data?.status === isSuccess) {

            const staffMembers = data?.data?.serviceUsers
            const filteredRows = filterRowsByProperty(
                staffMembers,
                (row) => row?.suFirstMiddleName
            );
            // setUserData(filteredRows);
            setFilteredRows(filteredRows);
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const response = await getRecords(GET_HISTORIC_CLIENTS_REPORT, apiQuery);
        console.log("🚀 ~ fetchAllRecords ~ response:", response)

        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);






    const columns = [
        {
            name: "#",
            selector: (row, index) => (
                <span >
                    {index + 1}
                </span>
            ),
            width: "5%",
            center: true,
        },
        {
            name: "Name",
            selector: (row) => {
                return (
                    <span
                        className="usersNameInfo py-2"
                    >
                        <span className="userInfo">
                            <span className="nameBlock">{`${row?.suFirstMiddleName}`}{" "}{`${row?.suLastName}`}</span>
                            <small className="nameBlock">Email: <a
                                href={`mailto:${row?.suEmailHome}`}
                                className="blackColor"

                            >
                                {row?.suEmailHome}
                            </a></small>
                            <small className="nameBlock">Age: {row?.suAge}&nbsp;({row?.suSex})</small>
                        </span>
                    </span>
                );
            },
            width: "25%",
        },
        // {
        //   name: "Provider Name",
        //   selector: (row) => {
        //     return (
        //       <>
        //         <span className="text-capitalize">{row?.providerName}</span>
        //       </>
        //     );
        //   },
        //   wrap: true,
        // },
        {
            name: "Address",
            selector: (row) => {
                return (
                    <>
                        <span className="text-capitalize">{row?.suAddress1}&nbsp;{row?.suAddress2}</span>&nbsp;
                        <span className="text-capitalize">{row?.suState}&nbsp;{row?.suCity}&nbsp;{row?.suZip}&nbsp;{row?.suCountry}</span>
                    </>
                );
            },
            wrap: true,
        },
        {
            name: "Dates",
            selector: (row) => {
                return (
                    <>

                        <span
                            className="usersNameInfo py-2"
                        >
                            <span className="userInfo">
                                <span className="nameBlock">DOB: {row?.suDOB ? moment(row?.suDOB).format("DD-MM-YYYY") : "-"}</span>
                                <span className="nameBlock">DOA: {row?.suFirstVisitDate ? moment(row?.suFirstVisitDate).format("DD-MM-YYYY") : "-"}</span>
                            </span>
                        </span>

                    </>
                );
            },
            wrap: true,
        },
        {
            name: "NOK Details",
            selector: (row) => {
                return (
                    <>

                        <span
                            className="usersNameInfo py-2"
                        >
                            <span className="userInfo">
                                <span className="nameBlock">Name: {`${row?.nokName}`}</span>
                                <small className="nameBlock">Email: <a
                                    href={`mailto:${row?.nokEmail}`}
                                    className="blackColor"

                                >
                                    {row?.nokEmail}
                                </a></small>
                                <small className="nameBlock">Relationship: {row?.nokRelationship}</small>
                                <small className="nameBlock">Mobile: {row?.nokMobile}</small>
                            </span>
                        </span>

                    </>
                );
            },
            wrap: true,
        },
        {
            name: "Contact No.",
            selector: (row) => {
                return (
                    <>
                        <div className="py-2">
                            <a
                                href={`tel:${row?.suMobileHomeNo}`}
                                className="blackColor"

                            >
                                Home: {row?.suMobileHomeNo}
                            </a>
                            <br />
                            {/* <a
                                href={`tel:${row?.suMobileWorkNo}`}
                                className="blackColor"

                            >
                                Work: {row?.suMobileWorkNo}
                            </a>
                            <br /> */}
                            <a
                                href={`tel:${row?.suEmergencyContact}`}
                                className="blackColor"

                            >
                                Emergency: {row?.suEmergencyContact}
                            </a>
                        </div>

                    </>
                );
            },
            wrap: true,
        },
    ];

    const filteredColumns = filterColumns(columns, (column) => column !== null);


    // Export Data

    const styles = StyleSheet.create({
        pages: {
            padding: "10px",
        },
        sectionTitle: {
            fontSize: "16px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        sectionSubTitle: {
            fontSize: "14px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1,
        },
        tableHead: {
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#f0f0f0",
            padding: "10px 10px",
            marginBottom: "5px",
            fontSize: "10px",
            fontWeight: "bold",
            wordWrap: "break-word",
        },
        tabBody: {
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "10px 10px",
            borderBottom: "1px solid #ccc",
            fontSize: "10px",
            wordWrap: "break-word",
        },
        wordwrap: {
            flexBasis: "50%",
            wordWrap: "break-word",
        },
    });

    const MyDocument = (start) => (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.pages}>
                <View>
                    <Text style={styles.sectionTitle}>Historic Client Reports</Text>
                    <View style={styles.tableHead}>
                        <Text style={{ width: "30%" }}>Name</Text>
                        <Text style={{ width: "30%" }}>Address</Text>
                        <Text style={{ width: "20%" }}>DOB</Text>
                        <Text style={{ width: "20%" }}>Contact No.</Text>
                    </View>
                    {filteredRows.map((row, index) => (
                        <View key={index} style={styles.tabBody}>
                            <Text style={{ width: "30%" }}>
                                {`${row?.suFirstMiddleName && row?.suFirstMiddleName}`}{" "}{`${row?.suLastName !== null && row?.suLastName !== undefined ? row?.suLastName : ""}\n`}
                                {`${row.suEmailHome && 'Email: ' + row.suEmailHome + `\n`}`}
                                {row?.suAge && `Age: ${row.suAge} (${row.suSex})\n`}
                            </Text>
                            <Text style={{ width: "30%" }}>
                                {row?.suAddress1}&nbsp;{row?.suAddress2}&nbsp;
                                {row?.suState}&nbsp;{row?.suCity}&nbsp;{row?.suZip}&nbsp;{row?.suCountry}
                            </Text>
                            <Text style={{ width: "20%" }}>{moment(row.suDOB).format("DD/MM/YYYY")}</Text>
                            <Text style={{ width: "20%" }}>
                                Home: {row?.suMobileHomeNo ? row?.suMobileHomeNo + `\n` : "-"}
                                {/* Work: {row?.suMobileWorkNo ? row?.suMobileWorkNo + `\n` : "-"} */}
                                Emergency: {row?.suEmergencyContact ? row?.suEmergencyContact : "-"}
                            </Text>
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );

    const ExportButton = ({ data, data2, patientName, removeMoreColumns }) => {
        const handleExport = () => {
            // Preprocess data to format dates before exporting
            const formattedData = data.map(
                ({
                    ...item
                }) => {
                    const suFirstVisitDate = moment(item?.suFirstVisitDate).format("DD/MM/YYYY") || "";
                    const suLastVisitDate = moment(item?.suLastVisitDate).format("DD/MM/YYYY") || "";
                    const suDOB = moment(item?.suDOB).format("DD/MM/YYYY") || "";
                    removeMoreColumns.forEach((column) => {
                        delete item[column];
                    });

                    return {
                        ...item,
                        suDOB: suDOB,
                        suDOA: suFirstVisitDate,
                        suLastVisitDate: suLastVisitDate,
                    };
                }
            );

            const formattedData2 = [{ "Historic Client Reports": patientName }];

            const fileType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const fileName = patientName;

            // Convert dataWithTitles array to worksheet
            let ws = XLSX.utils.json_to_sheet(formattedData2);

            // Add second data set to existing worksheet
            const ws2 = XLSX.utils.json_to_sheet(formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: true,
            });

            XLSX.utils.sheet_add_json(ws, formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: false,
                origin: -1,
            });

            // Create workbook
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

            // Write workbook to array buffer
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

            // Convert array buffer to Blob
            const blob = new Blob([excelBuffer], { type: fileType });

            // Create download link and trigger download
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName + fileExtension;
            a.click();
            // Add activity log AFTER download
            addActivityLog({
                message: `Download in Excell`,
                module: "Historic Client Reports",
            });
        };

        return <span onClick={handleExport}>Export as xlsx</span>;
    };

    return (
        <>
            <Layout pageTitleText="Historic Client Reports">
                <header className="headerContainerSearchAction">
                    <div className="actionButtons">
                        <div className="gap-1">
                            <a className="btn btn-sm btn-primary" href="/reports">
                                Back to Reports
                            </a>
                            <>
                                {
                                    filteredRows.length > 0 && (
                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-success" size="sm" id="dropdown-basic">
                                                Export Data
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="exportDataList">
                                                <>
                                                    {/* <span className="">
                                                        <PDFDownloadLink document={<MyDocument columns={columns} data={filteredColumns} />} fileName={"Historic Client Reports"}>
                                                            {({ loading }) =>
                                                                loading ? '...' : 'Export as PDF'
                                                            }
                                                        </PDFDownloadLink>
                                                    </span> */}
                                                    <span className="">
                                                        <ExportButton data={filteredRows} patientName={"Historic Client Reports"} removeMoreColumns={["suTitle", "currSU", "_id", "diagnosises", "aboutPatient", "shifts", "serviceUserMedications", "homeVisitSignOut", "srUsShiftsRequired", "active", "createdAt", "updatedAt", "__v", "addedby", "lastModifiedBy", "user", "suFirstVisitDate", "suLastVisitDate"]} />
                                                    </span>
                                                </>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )
                                }
                            </>
                        </div>
                    </div>
                </header>
                {/* <PDFViewer style={{ width: "100%", height: "300px" }}>
                    <MyDocument />
                </PDFViewer> */}

                <div className="mainContent noCursorPointer">
                    <div className="dataTableWrapper staffRecordsGroupsTable">
                        <DataTable
                            className="maxWidthTable"
                            columns={filteredColumns}
                            data={filteredRows}
                            fixedHeader
                            fixedHeaderScrollHeight="520px"
                            highlightOnHover
                            responsive={true}
                            subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                            progressPending={isLoading}
                            progressComponent={<ProgressComponent />}
                        />
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default HistoricClientReports;
